export function BlinkingIndicator() {
  return (
    <>
      <span className='relative w-6 flex items-center justify-center pr-1'>
        <span 
          className="absolute w-6 h-6 bg-mint rounded-full opacity-30"
          style={{
            animation: 'breathing 2s infinite'
          }}
        />
        <span className="absolute w-3 h-3 bg-mint rounded-full"></span>
      </span>

      <style>
        {`
          @keyframes breathing {
            0%   { transform: scale(0); opacity: 0.4; }
            40%  { transform: scale(1); opacity: 0.4; }
            100% { opacity: 0; }
          }
        `}
      </style>
    </>
  );
};
